<template>
  <header class="sticky top-0 z-30 glass-strong border-b border-orange-100 header" data-no-intercept>
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex items-center justify-between h-16">
        <!-- 左侧：Logo和汉堡菜单 -->
        <div class="flex items-center space-x-4">
          <!-- 移动端汉堡菜单 -->
          <button
            class="md:hidden btn-icon"
            @click="$emit('toggle-sidebar')"
            data-nav
          >
            <Menu class="w-6 h-6 text-orange-600" />
          </button>

          <!-- Logo -->
          <router-link to="/" class="flex items-center space-x-3" data-router-link>
            <div class="w-16 h-16 rounded-full overflow-hidden">
              <img src="/logo.png" alt="猫星球 Logo" class="w-full h-full object-cover" />
            </div>
            <div class="hidden sm:block">
              <h1 class="text-xl font-bold text-brand-gradient">猫星球</h1>
              <p class="text-xs text-gray-500">科学养猫上猫星球</p>
            </div>
          </router-link>
        </div>

        <!-- 中间：搜索框（仅桌面端） -->
        <div class="hidden md:flex flex-1 max-w-md mx-8" data-search>
          <div class="relative w-full">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search class="h-5 w-5 text-gray-400" />
            </div>
            <input
              v-model="searchQuery"
              type="text"
              placeholder="搜索猫咪用品..."
              class="w-full pl-10 pr-4 py-2 border-2 border-orange-200 rounded-full focus:ring-2 focus:ring-orange-300 focus:border-orange-500 transition-all duration-200 outline-none"
              @keyup.enter="handleSearch"
              data-search
            />
          </div>
        </div>

        <!-- 右侧：操作按钮 -->
        <div class="flex items-center space-x-2">
          <!-- 移动端搜索按钮 -->
          <button class="md:hidden btn-icon" @click="toggleMobileSearch" data-search>
            <Search class="w-5 h-5 text-orange-600" />
          </button>

          <!-- 购物车 -->
          <button class="btn-icon relative" @click="showQRModal('完整购物体验，尽在猫星球APP', '扫描二维码下载猫星球APP，享受更便捷的购物体验和专属优惠')" data-download>
            <Download class="w-6 h-6 text-orange-600" />
            <span class="absolute -top-2 -right-1 bg-red-500 text-white text-[9px] rounded-full w-11 h-5 flex items-center justify-center">
              下载APP
            </span>
          </button>

          <!-- APP下载按钮 -->
          <!-- <button class="btn-secondary" @click="showQRModal">
            <Download class="w-4 h-4 mr-2" />
            下载APP
          </button> -->
        </div>
      </div>

      <!-- 移动端搜索框 -->
      <Transition name="mobile-search">
        <div v-if="showMobileSearch" class="md:hidden pb-4" data-search>
          <div class="relative">
            <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search class="h-5 w-5 text-gray-400" />
            </div>
            <input
              v-model="searchQuery"
              type="text"
              placeholder="搜索猫咪用品..."
              class="w-full pl-10 pr-4 py-2 border-2 border-orange-200 rounded-full focus:ring-2 focus:ring-orange-300 focus:border-orange-500 transition-all duration-200 outline-none"
              @keyup.enter="handleSearch"
              data-search
            />
          </div>
        </div>
      </Transition>
    </div>


  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { Menu, Search, ShoppingCart, Download } from 'lucide-vue-next'
import { useAppDownload } from '@/composables/useAppDownload'

// 定义事件
defineEmits<{
  'toggle-sidebar': []
}>()

const router = useRouter()

// 响应式数据
const searchQuery = ref('')
const showMobileSearch = ref(false)

// 全局APP下载功能
const { showQRModal } = useAppDownload()

// 方法
const handleSearch = () => {
  if (searchQuery.value.trim()) {
    router.push({ path: '/store', query: { search: searchQuery.value } })
  }
}

const toggleMobileSearch = () => {
  showMobileSearch.value = !showMobileSearch.value
}


</script>

<style scoped>
/* 移动端搜索框动画 */
.mobile-search-enter-active,
.mobile-search-leave-active {
  transition: all 0.3s ease;
}

.mobile-search-enter-from {
  opacity: 0;
  transform: translateY(-10px);
}

.mobile-search-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>